module.exports = __webpack_public_path__ + "img/AI Icon.7030c991.svg";